function _typeof(obj) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj);
}
import "@nord/ui/es/Text/style/css";
import _Text from "@nord/ui/es/Text";
import "@nord/ui/es/Link/style/css";
import _Link from "@nord/ui/es/Link";
var _excluded = ["isSubmitting", "onSubmit"], _excluded2 = ["handleSubmit", "submitSucceeded", "values"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols);
} return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); });
} return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
}
else {
    obj[key] = value;
} return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null)
    return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object")
        return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
} return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null)
    return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0)
            continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key))
            continue;
        target[key] = source[key];
    }
} return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null)
    return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
        continue;
    target[key] = source[key];
} return target; }
import { useCallback } from 'react';
import { Form as ReactForm } from 'react-final-form';
import { Link as RouterLink } from 'react-router-dom';
import SuccessAlert from '@nordvpn/teams.core/lib/molecules/Alert/Success';
import { FormError } from '@nordvpn/teams.core/lib/molecules/Form/FormError';
import PasswordField from '@nordvpn/teams.core/lib/molecules/Form/PasswordField';
import Submit from '@nordvpn/teams.core/lib/molecules/Form/Submit';
import { isSubmitDisabled } from '@nordvpn/teams.core/lib/tools/isSubmitDisabled';
import { isPasswordSecure, passwordValidationV2, repeatedPasswordValidation } from 'validation/password';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var ResetPasswordForm = function ResetPasswordForm(_ref) {
    var isSubmitting = _ref.isSubmitting, onSubmit = _ref.onSubmit, restProps = _objectWithoutProperties(_ref, _excluded);
    var _restProps$submitSucc = restProps.submitSucceededAlert, submitSucceededAlert = _restProps$submitSucc === void 0 ? 'Password has been reset. You can now log in.' : _restProps$submitSucc, _restProps$backToLogi = restProps.backToLoginText, backToLoginText = _restProps$backToLogi === void 0 ? 'Back to Login' : _restProps$backToLogi, _restProps$formHeader = restProps.formHeader, formHeader = _restProps$formHeader === void 0 ? 'Almost done. Enter your new password, and from now on you will be able to use it connecting to the application on your devices.' : _restProps$formHeader, _restProps$formSecure = restProps.formSecurePasswordAlert, formSecurePasswordAlert = _restProps$formSecure === void 0 ? 'Your password is secure' : _restProps$formSecure, _restProps$newPasswor = restProps.newPasswordLabel, newPasswordLabel = _restProps$newPasswor === void 0 ? 'New password' : _restProps$newPasswor, _restProps$repeatPass = restProps.repeatPasswordLabel, repeatPasswordLabel = _restProps$repeatPass === void 0 ? 'Repeat password' : _restProps$repeatPass, _restProps$resetPassw = restProps.resetPasswordButtonText, resetPasswordButtonText = _restProps$resetPassw === void 0 ? 'Reset password' : _restProps$resetPassw;
    var validate = useCallback(function (_ref2) {
        var password = _ref2.password, repeatPassword = _ref2.repeat_password;
        return _objectSpread(_objectSpread({}, passwordValidationV2(password, 'password')), repeatedPasswordValidation(password, repeatPassword, 'repeat_password'));
    }, []);
    var content = useCallback(function (_ref3) {
        var handleSubmit = _ref3.handleSubmit, submitSucceeded = _ref3.submitSucceeded, values = _ref3.values, restFormProps = _objectWithoutProperties(_ref3, _excluded2);
        return submitSucceeded ? /*#__PURE__*/ _jsxs(_Fragment, {
            children: [/*#__PURE__*/ _jsx(SuccessAlert, {
                    className: "reset-password-success-alert",
                    "data-testid": "reset-success-alert",
                    children: submitSucceededAlert
                }), /*#__PURE__*/ _jsx(_Text, {
                    variant: "body2",
                    className: "font-medium mt-4",
                    children: /*#__PURE__*/ _jsx(_Link, {
                        "data-testid": "back-to-login",
                        component: RouterLink,
                        colorClassName: "text-blue",
                        to: "",
                        children: backToLoginText
                    })
                })]
        }) : /*#__PURE__*/ _jsxs("form", {
            autoComplete: "off",
            onSubmit: handleSubmit,
            children: [/*#__PURE__*/ _jsx("div", {
                    className: "reset-password-form-subtitle text-small leading-24 mb-4",
                    children: formHeader
                }), /*#__PURE__*/ _jsx(PasswordField, {
                    id: "password-field",
                    name: "password",
                    label: newPasswordLabel,
                    required: true
                }), isPasswordSecure(values.password) && /*#__PURE__*/ _jsx(SuccessAlert, {
                    "data-testid": "secure-alert",
                    className: "mb-16",
                    children: formSecurePasswordAlert
                }), /*#__PURE__*/ _jsx(PasswordField, {
                    id: "password-repeat-field",
                    name: "repeat_password",
                    label: repeatPasswordLabel
                }), /*#__PURE__*/ _jsx(Submit, {
                    loading: isSubmitting,
                    className: "w-full my-3",
                    formProps: restFormProps,
                    "data-testid": "submit-reset-password",
                    disabled: isSubmitting || isSubmitDisabled(restFormProps),
                    children: resetPasswordButtonText
                }), /*#__PURE__*/ _jsx(FormError, {})]
        });
    }, [submitSucceededAlert, formHeader, formSecurePasswordAlert, newPasswordLabel, repeatPasswordLabel, resetPasswordButtonText, backToLoginText, isSubmitting]);
    return /*#__PURE__*/ _jsx(ReactForm, {
        onSubmit: onSubmit,
        validate: validate,
        render: content
    });
};
export default ResetPasswordForm;
